<template>
  <div>
    <template v-if="view_transfer_in === true">
      <div class="page-top mb-1 mb-3 clearfix">
        <h1 class="float-left"> Transfer IN </h1>
      </div>

      <div class="page-top mb-1 mb-3 clearfix">
        <!--              <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">-->
        <!--                <li class="nav-item">-->
        <!--                  <a class="nav-link active" id="new-tab"  data-toggle="tab" href="#new" role="tab" aria-controls="new" aria-selected="true" @click="reloadList('new')" >New ({{new_transaction_count}})</a>-->
        <!--                </li>-->
        <!--                <li class="nav-item">-->
        <!--                  <a class="nav-link" id="inprocess-tab" data-toggle="tab" href="#inprocess" role="tab" aria-controls="inprocess" aria-selected="false" @click="reloadList('inprocess')" >In Process ({{inprocess_transaction_count}})</a>-->
        <!--                </li>-->
        <!--                <li class="nav-item">-->
        <!--                  <a class="nav-link" id="rejected-tab"  data-toggle="tab" href="#rejected" role="tab" aria-controls="rejected" aria-selected="false" @click="reloadList('rejected')" >Rejected ({{rejected_transaction_count}})</a>-->
        <!--                </li>-->
        <!--                <li class="nav-item">-->
        <!--                  <a class="nav-link" id="paid-tab" data-toggle="tab" href="#paid" role="tab" aria-controls="paid" aria-selected="false" @click="reloadList('paid')" >Paid ({{paid_transaction_count}})</a>-->
        <!--                </li>-->
        <!--              </ul>-->
        <router-link v-if="crud_transfer_in && transfer_in_maker" to="/bulkTransferIn" class="btn btn-primary float-right mr-1"> New Batch - Bulk Transfer In</router-link>
        <router-link v-if="crud_transfer_in && transfer_in_maker" to="/financeTransferIn" class="btn btn-primary float-right mr-1"> New Batch </router-link>
      </div>

      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
          <table id="dt-new" class="table" style="width:100%">
            <thead>
            <tr>
              <th style="display: none;"></th>
              <th>Batch</th>
              <th>Inserted</th>
              <th>Updated</th>
              <th>Discrepants</th>
              <th>Date</th>
              <th>Status</th>
              <th class="text-center">Action</th>
            </tr>
            </thead>
          </table>
        </div>
        <div class="tab-pane fade" id="inprocess"  role="tabpanel" aria-labelledby="inprocess-tab">
          <div class="table-holder">
            <table id="dt-inprocess" class="table table-responsive-xl" style="width:100%">
              <thead>
              <tr>
                <th style="display: none;"></th>
                <th>Batch</th>
                <th>Inserted</th>
                <th>Updated</th>
                <th>Discrepants</th>
                <th>Date</th>
                <th>Status</th>
                <th class="text-center">Action</th>
              </tr>
              </thead>
            </table>
          </div>
        </div>
        <div class="tab-pane fade" id="rejected"  role="tabpanel" aria-labelledby="rejected-tab">
          <div class="table-holder">
            <table id="dt-rejected" class="table table-responsive-xl" style="width:100%">
              <thead>
              <tr>
                <th style="display: none;"></th>
                <th>Batch</th>
                <th>Inserted</th>
                <th>Updated</th>
                <th>Discrepants</th>
                <th>Date</th>
                <th>Status</th>
                <th class="text-center">Action</th>
              </tr>
              </thead>
            </table>
          </div>
        </div>
        <div class="tab-pane fade" id="paid" role="tabpanel" aria-labelledby="paid-tab">
          <div class="table-holder">
            <table id="dt-paid" class="table table-responsive-xl" style="width:100%">
              <thead>
              <tr>
                <th style="display: none;"></th>
                <th>Batch</th>
                <th>Inserted</th>
                <th>Updated</th>
                <th>Discrepants</th>
                <th>Date</th>
                <th>Status</th>
                <th class="text-center">Action</th>
              </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>

    </template>
    <template v-else-if="view_transfer_in === null">
      <preLoader></preLoader>
    </template>
    <template v-else-if="view_transfer_in === false">
      <notAllowed></notAllowed>
    </template>

  </div>
</template>

<script>
var gThat = null;
export default {
  data() {
    return {
      companies: [],
      listingData:[],
      form: new Form({
        company_id: '',
        amount : '',
        // transaction_id : '',
        transaction_ref : '',
        description : '',
        date:new Date()
      }),
      new_transaction_count : 0,
      inprocess_transaction_count : 0,
      rejected_transaction_count : 0,
      paid_transaction_count: 0,
      dtNewBPayments: null,
      dtInProcessBPayments: null,
      dtRejectedBPayments: null,
      dtPaidBPayments: null,

      view_transfer_in: null,
      crud_transfer_in:null,
      transfer_in_maker:null
    }
  },
  methods: {

    submitForm(){
      swal.fire({
        title: "Please Confirm!",
        text: "Are you sure you want to submit?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        closeOnConfirm: false,
        closeOnCancel: false
      }).then((result) => {
        if (result.value) {
          this.insertData();
        }
      });
    },
    insertData() {
      this.$Progress.start();
      this.form.date = moment(this.form.date).format();
      this.form.post('/api/financeTransferIn')
          .then(res => {
            if(res.status == 200){
              $('#transferIn')[0].reset();
              $(this.$el).find('.selectpicker').selectpicker('refresh');
              toast.fire({
                type: 'success',
                title: 'Record successfully added'
              });
              // this.$router.push('/financeLedgerReport');
              this.$Progress.finish();
            }else{
              $(this.$el).find('.selectpicker').selectpicker('refresh');
              this.$Progress.fail();
            }
          })
          .catch(err => {
            this.$Progress.fail();
            $(this.$el).find('.selectpicker').selectpicker('refresh');
            this.showAlertBox('error','Some problem in your form data');
          });

    },
    selectpickerOnchange(){
      var select=this.$el;
      setTimeout(()=>{
        $(select).find('.selectpicker').selectpicker('refresh');
      },0);
    },
    getCompanies(){
      this.$Progress.start();
      axios.get('/api/getCompanies')
          .then(res => {
            if(res.status == 200){
              this.companies = res.data;
              this.$Progress.finish();
            }else{
              this.$Progress.fail();
              this.showAlertBox('error','Some error in your form data');
            }
          }).then(res => {
        $(this.$el).find('.selectpicker').selectpicker('refresh');
      })
          .catch(err => {
            $(this.$el).find('.selectpicker').selectpicker('refresh');
            this.showAlertBox('error','Some error in your form data');
          });
    },

    newListData: function(){
      var showBox = gThat.process_bill;
      gThat.dtNewBPayments = $('#dt-new').DataTable({
        processing: true,
        serverSide: true,
        searching: false,
        sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
        ajax: {
          //"url": "api/getBillNewList",
          "url": "api/listNewBulkTransferIn",
          "headers": window.axios.defaults.headers.common,
          "dataSrc": "records",
          "complete": function (data,json, type) {
            gThat.listingData = data.responseJSON.records;
            if (type == "parsererror") {
              gThat.$Progress.fail();
            }else{
              gThat.$Progress.finish();
            }
          }
        },
        deferRender: true,
        columns: [
          {data: 'id', visible: false},
          {data: 'batch'},
          {data: 'inserted'},
          {data: 'updated'},
          {data: 'discrepants'},
          {
            data: 'created_at',
            render: function (data, type, row) {
              return "" + moment(row.created_at).format("MMM D, Y") + "";
            }
          },
          {
            data: 'status',
            render: function(data, type, row) {
              const status = row.status;
              if (status === 'UPLOAD') {
                return '<span class="status uploaded">Uploaded </span>';
              } else if (status === 'UNDERREVIEW') {
                return '<span class="status uploaded">Under Review </span>';
              } else if (status === 'CHECKED') {
                return '<span class="status checked"> Checked </span>';
              } else if (status === 'PARTIAL') {
                return '<span class="status partial">Partial  </span>';
              } else if (status === 'APPROVED') {
                return '<span class="status processing"> Processed </span>';
              } else if (status === 'DISAPPROVED') {
                return '<span class="status disapproved">Disapproved </span>';
              } else if (status === 'FLAGGED') {
                return '<span class="status flagged"> Flagged </span>';
              } else if (status === 'ARCHIVED') {
                return '<span class="status">Archive  </span>';
              } else if (status === 'INPROCESS') {
                return '<span class="status processing"> In Process  </span>';
              } else if (status === 'ERROR') {
                return '<span class="status disapproved"> Error  </span>';
              } else if (status === 'REJECTED') {
                return '<span class="status rejected"> Rejected  </span>';
              } else if (status === 'SUBMITTED') {
                return '<span class="status uploaded"> Submitted  </span>';
              } else if (status === 'SUCCESS') {
                return '<span class="status checked"> Success  </span>';
              } else if (status === 'FAILED') {
                return '<span class="status disapproved"> Failed  </span>';
              } else {
                return status;
              }
            }
          },
          {"name":"title","mData": "title",
            "mRender": function (data, type, full) {
              var id = full['id'];
              var $url = "/viewBulkTransferInDetails/" + id;
              return (
                  //text-limit-10
                  '<a class="text-limit " href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
                  $url +
                  '\')"><strong class="elisp">Show Details</strong></a>'
              );
            }
          },
        ],
        "order": [[ 0, "desc" ]],
        "initComplete": (settings, json) => { this.new_bills_count = json.recordsTotal; }
      });
    },
    inprocessList: function(){
      gThat.dtInProcessBPayments = $('#dt-inprocess').DataTable({
        processing: true,
        serverSide: true,
        searching: false,
        sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
        ajax: {
          "url": "api/getBillInProcessList",
          "headers": window.axios.defaults.headers.common,
          "dataSrc": "records",
          "complete": function (json, type) {
            if (type == "parsererror") {
              gThat.$Progress.fail();
            }else{
              gThat.$Progress.finish();
            }
          }
        },
        deferRender: true,
        columns: [
          {data: 'id', visible: false},
          {data: 'title'},
          {data: 'reason'},
          {data: 'categoryName'},
          {data: 'reason'},
          {data: 'referenceNo'},
          {data: 'amountBill'},
          {data: 'status'},
          {data: 'id', sorting: false, render: function(data,type,full){
              var $url = 'viewBillPayment/'+full['id'];
              return '<a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="window.vueRouterPush(\''+$url+'\')" title="View" class="action view"> <i class="far fa-eye"></i> </a>';
            }}
        ],
        "order": [[ 0, "desc" ]],
        "initComplete": (settings, json) => { this.inprocess_bills_count = json.recordsTotal; }
      });
    },
    rejectedList: function(){
      gThat.dtRejectedBPayments = $('#dt-rejected').DataTable({
        processing: true,
        serverSide: true,
        searching: false,
        sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
        ajax: {
          "url": "api/getBillRejectedList",
          "headers": window.axios.defaults.headers.common,
          "dataSrc": "records",
          "complete": function (json, type) {
            if (type == "parsererror") {
              gThat.$Progress.fail();
            }else{
              gThat.$Progress.finish();
            }
          }
        },
        deferRender: true,
        columns: [
          {data: 'id', visible: false},
          {data: 'title'},
          {data: 'reason'},
          {data: 'categoryName'},
          {data: 'reason'},
          {data: 'referenceNo'},
          {data: 'amountBill'},
          {data: 'status'},
          {data: 'id', sorting: false, render: function(data,type,full){
              var $url = 'viewBillPayment/'+full['id'];
              return '<div class="align-center"><a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="window.vueRouterPush(\''+$url+'\')" title="View" class="action view"> <i class="far fa-eye"></i> </a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+',\''+full['status']+'\')"  data-toggle="tooltip" data-placement="top" title="Delete" class="softDelete"> <i class="fas fa-trash-alt"></i> </a></div>';
            }}
        ],
        "order": [[ 0, "desc" ]],
        "initComplete": (settings, json) => { this.rejected_bills_count = json.recordsTotal; }
      });
    },
    paidList: function(){
      gThat.dtPaidBPayments = $('#dt-paid').DataTable({
        processing: true,
        serverSide: true,
        searching: false,
        sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
        ajax: {
          "url": "api/getBillPaidList",
          "headers": window.axios.defaults.headers.common,
          "dataSrc": "records",
          "complete": function (json, type) {
            if (type == "parsererror") {
              gThat.$Progress.fail();
            }else{
              gThat.$Progress.finish();
            }
          }
        },
        deferRender: true,
        columns: [
          {data: 'id', visible: false},
          {data: 'title'},
          {data: 'reason'},
          {data: 'categoryName'},
          {data: 'reason'},
          {data: 'referenceNo'},
          {data: 'amountBill'},
          {data: 'status'},
          {data: 'id', sorting: false, render: function(data,type,full){
              var $url = 'viewBillPayment/'+full['id'];
              return '<a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="window.vueRouterPush(\''+$url+'\')" title="View" class="action view"> <i class="fas fa-eye"></i> </a>'+
                  '<a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="VueComponents.billPaymentsComponent.methods.downloadBillSlip(\''+full['id']+'\')" title="Download" class="action view"> <i class="fas fa-download"></i> </a>' +
                  '<a href="javascript:void(0)" data-toggle="tooltip" data-placement="top" onclick="VueComponents.billPaymentsComponent.methods.fetchNewBill(\''+full['id']+'\')" title="Fetch Again" class="action view"> <i class="fas fa-sync-alt"></i></a>';
            }}
        ],
        "order": [[ 0, "desc" ]],
        "initComplete": (settings, json) => { this.paid_bills_count = json.recordsTotal; }
      });
    },
    reloadList(tabClicked){

      switch(tabClicked)
      {
        case 'new':
          if(gThat.currentActiveTab !== 'new')
          {
            gThat.isDataTableLoading = true;

            gThat.dtNewBPayments.ajax.reload(function(json){
              gThat.new_transaction_count 	= json.recordsTotal;
              gThat.isDataTableLoading 	= false;
            }, false);

            gThat.currentActiveTab = 'new';
          }
          break;

        case 'inprocess':
          if(gThat.currentActiveTab !== 'inprocess')
          {
            gThat.isDataTableLoading = true;

            gThat.dtInProcessBPayments.ajax.reload(function(json){
              gThat.inprocess_transaction_count 	= json.recordsTotal;
              gThat.isDataTableLoading 		= false;
            }, false);

            gThat.currentActiveTab = 'inprocess';
          }
          break;

        case 'rejected':
          if(gThat.currentActiveTab !== 'rejected')
          {
            gThat.isDataTableLoading = true;

            gThat.dtRejectedBPayments.ajax.reload(function(json){
              gThat.rejected_transaction_count 	= json.recordsTotal;
              gThat.isDataTableLoading 		= false;
            }, false);

            gThat.currentActiveTab = 'rejected';
          }
          break;

        case 'paid':
          if(gThat.currentActiveTab !== 'paid')
          {
            gThat.isDataTableLoading = true;

            gThat.dtPaidBPayments.ajax.reload(function(json){
              gThat.paid_transaction_count = json.recordsTotal;
              gThat.isDataTableLoading 		= false;
            }, false);

            gThat.currentActiveTab = 'paid';
          }
          break;
      }
    },
  },
  mounted() {

    gThat = this;
    this.$Progress.start();
    this.can('transfer_in|crud_transfer_in|transfer_in_maker').then(result => {
      this.view_transfer_in = result.transfer_in;
      this.crud_transfer_in = result.crud_transfer_in;
      this.transfer_in_maker = result.transfer_in_maker;
    }).then(result => {
      if(this.view_transfer_in == true){
         this.newListData();
        // this.inprocessList();
        // this.rejectedList();
        // this.paidList();
        this.getCompanies();
        this.$Progress.finish();
      }else{
        this.$Progress.finish();
      }
    });
  }
}
</script>
